import { atom } from 'recoil'

export default atom({
  key: 'userDefinedLegends',
  default: {},
})
